<template>
    <div>
        <div class="title-container">
            <span>{{ title }}</span>
        </div>
        <div class="amount-container">
            <div>
                <i
                    v-for="(n, index) in levelAll"
                    :key="`${index} ${title}`"
                    class="icon-content"
                    :class="`${icon}`"
                    :style="`${n.value == true ? 'color:' + colorActive : ''}`"
                    @click="selectLevel(n)"
                >
                    <span class="number" v-if="type == 'number'">{{
                        index + 1
                    }}</span>
                </i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LevelCounter',
    props: [
        'level',
        'title',
        'amount',
        'icon',
        'type',
        'colorActive',
        'currentUser',
    ],
    created() {
        for (let i = 0; i < this.amount; i++) {
            this.levelAll.push({
                rating: i + 1,
                value: false,
            })
        }
    },
    mounted() {
        this.levelAll.forEach((item) => {
            if (item.rating <= this.level) {
                return (item.value = true)
            }
        })
    },
    data() {
        return {
            levelAll: [],
            selectedValue: this.level,
        }
    },
    methods: {
        selectLevel(n) {
            if (!this.currentUser) {
                const buttonCounter = document.querySelector('.icon-content')
                buttonCounter.style.cursor = 'none'
                return
            }
            this.selectedValue = n.rating
            this.$emit('levelSelected', n)
            this.levelAll.forEach((el) => {
                if (el.rating <= n.rating) el.value = true
                else el.value = false
            })
        },
    },
    watch: {
        level(valueNew) {
            return this.levelAll.forEach((el) => {
                if (el.rating <= valueNew) el.value = true
                else el.value = false
            })
        },
    },
}
</script>

<style lang="sass" scoped>
.icon-content
    position: relative
    font-size: 1.3rem
    margin-right: .5rem
    color: #bec0c0
    cursor: pointer
    .number
        position: absolute
        font-size: 1rem
        color: #fff
        left: 6px
</style>
